var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "location-info" }, [
    _c(
      "div",
      { staticClass: "location-info__contacts" },
      _vm._l(_vm.contactsMap, function (department, key) {
        return _c(
          "div",
          { staticClass: "building-contacts__property u-sec-margin-bottom" },
          [
            _c("label", { staticClass: "building-contacts__contacts--label" }, [
              _vm._v(_vm._s(_vm.$t("tenancy." + key))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "location-info__contacts--group" }, [
              _c("div", { staticClass: "location-info__contacts--title" }, [
                _c("div", { staticClass: "title__name" }, [
                  _vm._v(_vm._s(_vm.$t("settings.building.name"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "title__role" }, [
                  _vm._v(_vm._s(_vm.$t("settings.building.role"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "location-info__contacts--list" },
                _vm._l(department, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "list__item",
                      class: !item.userId ? "error-highlight" : "",
                    },
                    [
                      _vm.isEditable
                        ? _c("HKLSelect", {
                            staticClass: "list__item--name",
                            attrs: {
                              disabled: false,
                              required: true,
                              options: _vm.contactHklOptions,
                              value: item.userId,
                              showSearch: true,
                              placeholder: "",
                            },
                            on: {
                              change: function (val) {
                                return _vm.updateOneContactById(
                                  item.hashIndex,
                                  val
                                )
                              },
                            },
                          })
                        : _c("div", { staticClass: "list__item--name" }, [
                            _vm._v(
                              _vm._s(_vm._f("isEmptyValue")(item.displayName))
                            ),
                          ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "list__item--role-group" },
                        [
                          _c("InputField", {
                            staticClass: "list__item--role",
                            attrs: {
                              showFlag: false,
                              showColon: false,
                              extendClass: "location-info__telephone--input",
                              readonly: !_vm.isEditable,
                            },
                            model: {
                              value: item.title,
                              callback: function ($$v) {
                                _vm.$set(item, "title", $$v)
                              },
                              expression: "item.title",
                            },
                          }),
                          _vm._v(" "),
                          _vm.isEditable
                            ? _c(
                                "div",
                                {
                                  staticClass: "list__item--delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteOneContact(
                                        item.hashIndex
                                      )
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa fa-times fa-lg" })]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.isEditable
              ? _c(
                  "div",
                  {
                    staticClass: "location-info__contacts--add",
                    on: {
                      click: function ($event) {
                        return _vm.addOneContact(key)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("settings.building.addNewHkldContact")) +
                        " + "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }